document.addEventListener('DOMContentLoaded', function() {
  function slide_click() {
    $('#slide_content').slideToggle();
    $('.instruction_info p span').toggleClass('arrow_move');
  }

  $('.instruction_info p').click(slide_click);

  $('#insurance').click(function() {  
    const isSelected = $(this).data('status') === true;
    $(this).data('status', !isSelected);
    $(this).toggleClass('checked', !isSelected);
  });
});
